import { styled } from "@mui/material/styles";
import { Box, Link, Typography } from "@mui/material";
import { PATH_MY_ACCOUNT } from "src/routes/paths";
import { Link as RouterLink } from "react-router-dom";

const RootStyle = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(2, 2.5),
    borderRadius: Number(theme.shape.borderRadius) * 1.5,
    backgroundColor: theme.palette.grey[500_12],
    transition: theme.transitions.create("opacity", {
        duration: theme.transitions.duration.shorter,
    }),
}));

const RowStyle = styled("div")(() => ({
    display: "flex",
    alignItems: "center",
}));

type Props = {
    isCollapse: boolean | undefined;
    role?: string;
    company?: string;
};

export default function NavbarAccount({ isCollapse, role, company }: Props) {
    return (
        <Link component={RouterLink as any} to={PATH_MY_ACCOUNT} underline="none" color="inherit">
            <RootStyle
                sx={{
                    ...(isCollapse && {
                        bgcolor: "transparent",
                    }),
                }}
            >
                <RowStyle>
                    <Box
                        sx={{
                            transition: (theme) =>
                                theme.transitions.create("width", {
                                    duration: theme.transitions.duration.shorter,
                                }),
                            ...(isCollapse && {
                                ml: 0,
                                width: 0,
                            }),
                        }}
                    >
                        {company && (
                            <Typography
                                variant="subtitle2"
                                sx={{
                                    maxWidth: 200,
                                    overflow: "hidden",
                                    whiteSpace: "nowrap",
                                    textOverflow: "ellipsis",
                                }}
                            >
                                {company}
                            </Typography>
                        )}
                        {role && (
                            <Typography variant="body2" noWrap sx={{ color: "text.secondary" }}>
                                {role}
                            </Typography>
                        )}
                    </Box>
                </RowStyle>
            </RootStyle>
        </Link>
    );
}
